import { render, staticRenderFns } from "./TheCustomerFavorite.vue?vue&type=template&id=172c7552&scoped=true&lang=pug&"
import script from "./TheCustomerFavorite.vue?vue&type=script&lang=js&"
export * from "./TheCustomerFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c7552",
  null
  
)

export default component.exports